import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line
import { getDownloadAPI } from "@/store/restAPI.js";

// initial state
const state = {
  loading: false,
};

// getters
const getters = {};

// actions
const actions = {
  retrieveResearchOrders({ commit }, filter) {
    commit("SET_LOADING", true);
    return getAPI("researchOrder/retrieveResearchOrders" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveResearchOrdersBySearch({ commit } , filter) {
    commit("SET_LOADING", true);
    return getAPI("researchOrder/retrieveResearchOrdersBySearch" , filter).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  deleteResearchOrder({ commit } , id) {
    commit("SET_LOADING", true);
    return postAPI("researchOrder/deleteResearchOrder/" + id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveResearchOrderById({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("researchOrder/retrieveResearchOrderById" , id)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveResearchOrder({ commit }, researchOrder) {
    commit("SET_LOADING", true);
    return postAPI("researchOrder/saveResearchOrder", researchOrder).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  downloadPDF({ commit }, id) {
    commit("SET_LOADING", true);
    return getDownloadAPI("researchOrder/downloadPDF/" + id)
    .finally(() => commit("SET_LOADING", false));
  },

  countResearchOrders(context, filter) {
    // Don't set loading for count operations - it's a quick query and causes double loading
    // when called together with retrieveResearchOrders/retrieveResearchOrdersBySearch
    return getAPI("researchOrder/count", filter).then((res) => {
      return res;
    });
  },


};

// mutations
const mutations = {
  ...make.mutations(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};